import axios from 'axios';
import { renderToString } from 'react-dom/server'

import { convertQuestionsToArray } from '../../../../components/CASAForm/Utilities';
import { submissionBegin, submissionSuccess, submissionFailure } from '../GenericFormServiceActions/SubmissionAction';
import { addFormSubmissionFailed } from '../../FormPropertyAction/FormPropertyAction';

export const acrConfirmationSubmission = (webappurlForms, accessToken, formProperties, formData, declarationText) => {
    return dispatch => {
        const data = {
            "rootFormCode": formProperties.rootFormCode,
            "formCode": formProperties.formCode,
            "formData": {
                "steps": convertQuestionsToArray(formData.steps),
                "declarationText": renderToString(declarationText)},
            "name": formProperties.name,
            "version": formProperties.version,
            "orgid": formProperties.orgid,
            "organisationArn": formProperties.organisationArn
        }

        const options = {
            headers: {
                'Authorization': "Bearer " + accessToken,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        
        dispatch(submissionBegin());
        return axios.post(webappurlForms + "/api/myCASA/Forms/acrConfirmationSubmission/v1", { "data": btoa(escape(JSON.stringify(data))) }, options)
            .then(response => {
                if (response.data.wasSuccessful && response.data.id) {
                    return dispatch(submissionSuccess());
                }
                else {
                    dispatch(addFormSubmissionFailed())
                    return dispatch(submissionFailure(response.message));
                }
            })
            .catch(error => {
                if (error.response) {
                    dispatch(addFormSubmissionFailed())
                    return dispatch(submissionFailure(error.response.data.error));
                } 
                dispatch(addFormSubmissionFailed())
                return dispatch(submissionFailure(error));
            });
    };
}
